/* Route table for the v5 site.
 *
 * Imported by src/app.jsx (client routing) and scripts/prerender.mjs
 * (static snapshots). Keep this file free of JSX and browser globals so
 * Node can import it directly.
 */

import { PRODUCTS, INDUSTRIES } from './data.js';

// Parse a pathname into { page, key }. Unknown paths resolve to home.
export function parseRoute(pathname) {
  const [a, b] = (pathname || '/').replace(/^\/+|\/+$/g, '').split('/');
  if (a === 'product' && PRODUCTS.some(p => p.key === b)) return { page: 'product', key: b };
  if (a === 'solutions' && INDUSTRIES.some(d => d.key === b)) return { page: 'industry', key: b };
  if (a === 'about' && !b) return { page: 'about' };
  return { page: 'home' };
}

export function routePath(route) {
  if (route.page === 'product') return '/product/' + route.key;
  if (route.page === 'industry') return '/solutions/' + route.key;
  if (route.page === 'about') return '/about';
  return '/';
}

// Every public pathname, prerendered to dist/<path>/index.html.
export const PRERENDER_ROUTES = [
  '/',
  '/about',
  ...PRODUCTS.map(p => '/product/' + p.key),
  ...INDUSTRIES.map(d => '/solutions/' + d.key),
];
